import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../utils/Breadcrumb";
import { useStandard } from "../../../context/StandardContext";
import { Link, useParams } from "react-router-dom";
import { CloseIcon } from "../../../assets/icons";
import Calendar from "./Calender";
import NuDateFormat from "../../../utils/NuDate";
import UseGetData from "../../../hooks/useFetchData";
import ViewTaskDetails from "./ViewTaskDetails";

function CalendarManagementIndex() {
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const { data, getData } = UseGetData({ url: `/Calender-Management/standard/${stdId}` });
  const [showDetails, setShowDetails] = useState(false);
  const [taskShow, setTaskShow] = useState(false);
  const [taskDetails, setDetails] = useState({});
  const [dayDetails, setDayDetails] = useState({});
  const [filteredTasks, setFilteredTasks] = useState({
    pend: [],
    pendByReminder: [],
    comp: [],
    compByReminder: [],
    over: [],
    overByReminder: [],
  });

  const getDayName = (day) => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return days[day];
  };

  const updateFilteredTasks = () => {
    if (data && dayDetails?.startStr) {
      const { startStr } = dayDetails;

      // Filter tasks by completion_date and reminder_date
      const tasksByCompletionDate = data.filter((a) => a.completion_date == startStr);
      const tasksByReminderDate = data.filter((a) => a.reminder_date == startStr);

      // Function to filter tasks by status
      const filterByStatus = (tasks, status) => tasks.filter((a) => a.status === status);
      
      setFilteredTasks({
        pend: filterByStatus(tasksByCompletionDate, "in progress"),
        pendByReminder: filterByStatus(tasksByReminderDate, "in progress"),
        comp: filterByStatus(tasksByCompletionDate, "completed"),
        compByReminder: filterByStatus(tasksByReminderDate, "completed"),
        over: filterByStatus(tasksByCompletionDate, "yet to start"),
        overByReminder: filterByStatus(tasksByReminderDate, "yet to start"),
      });
    }
  };

  useEffect(() => {
    updateFilteredTasks();
  }, [data, dayDetails]);

  const showTaskDetails = (task) => {
    setDetails(task);
    setTaskShow(true);
  }

  const TaskList = ({ title, tasks }) => (
    <div className="bg-white h-auto rounded-lg shadow-box m-2">
      <div className="flex justify-between px-4 pt-3 pb-1">
        <h3 className={`text-xs 2xl:text-sm font-medium ${title.color}`}>{title.label}</h3>
      </div>
      <div className="px-4 pb-3 text-xs 2xl:text-sm font-medium">
        <ul className="list-disc">
          {tasks?.map((item) => (
            // <Link to={`/information/task-detail/view/${stdId}/${item.id}`} key={item.id}>
              <li className="mx-4 py-1 font-normal cursor-pointer" title={item?.comment} key={item.id} onClick={() => showTaskDetails(item)}>
                {item?.title || "-"}
              </li>
            // </Link>
          ))}
        </ul>
      </div>
    </div>
  );

  return (
    <>
        <div className="w-full h-full mx-auto">
      <div className="w-[93%] flex justify-start items-center gap-x-6 pb-1 px-3 mx-auto">
        <Breadcrumb
          items={[
            { name: "Standard", link: "/main/standard" },
            { name: standardName },
            { name: "Information" },
            { name: "Calendar Management" },
          ]}
        />
      </div>
      <div className="w-[96%] mx-auto h-[calc(100vh-105px)] p-2 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] rounded-2xl overflow-y-auto">
        <div className="py-1 px-4 w-6/12 lg:w-full flex items-center justify-between">
          <p className="text-xs 2xl:text-sm text-text">Calendar Management</p>
          <Link to={`/standard/${stdId}/information/task-management`}>
            <p className="text-xs text-blue-700 bg-gray-200 px-2 py-1 rounded shadow-box">Task</p>
          </Link>
        </div>
        <div className="flex gap-2 h-[calc(100vh-155px)] w-full">
          <div className={`${showDetails ? "w-[70%]" : "w-full"} bg-white rounded-lg shadow-box`}>
            <Calendar 
             Details={() => setShowDetails(true)} 
             setDayDetails={setDayDetails} 
             data={data}
             getData={getData}
             stdId={stdId}
             dayDetails={dayDetails}
             />
          </div>
          {showDetails && (
            <div className="w-[29.5%] bg-white rounded-lg shadow-box p-2">
              <h3 className="bg-tabletitle rounded-lg p-3 text-xs 2xl:text-sm font-medium flex items-center justify-between">
                <NuDateFormat value={dayDetails?.startStr} format="DD-MMM-YYYY" />
                {` (${getDayName(new Date(dayDetails.start).getDay())})`}
                <span
                  className="h-6 w-6 text-2xl block cursor-pointer"
                  onClick={() => setShowDetails(false)}
                >
                  <CloseIcon />
                </span>
              </h3>
              <div className="overflow-y-auto h-[calc(100vh-215px)]">
                <TaskList title={{ label: "Yet to Start", color: "text-overdue" }} tasks={[...filteredTasks.over, ...filteredTasks.overByReminder]} />
                <TaskList title={{ label: "In Progress", color: "text-[#ffd700]" }} tasks={[...filteredTasks.pend, ...filteredTasks.pendByReminder]} />
                <TaskList title={{ label: "Completed", color: "text-completed" }} tasks={[...filteredTasks.comp, ...filteredTasks.compByReminder]} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    <ViewTaskDetails visible={taskShow} onClose={()=>setTaskShow(false)} data={taskDetails} />
    </>
  );
}

export default CalendarManagementIndex;
